/**
 * Created by xiehan on 2019/02/19.
 */

import Logic from '../logic-base'

const workFlowTemplateManageBiz = new Logic()

workFlowTemplateManageBiz.findTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowTemplateManage.findTemplate,
    data: data
  })
}

workFlowTemplateManageBiz.findTemplateById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowTemplateManage.findTemplateById,
    data: data
  }, false, true)
}

workFlowTemplateManageBiz.saveTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowTemplateManage.saveTemplate,
    data: data
  })
}

workFlowTemplateManageBiz.updateTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowTemplateManage.updateTemplate,
    data: data
  })
}

workFlowTemplateManageBiz.deleteTemplate = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.workFlowTemplateManage.deleteTemplate,
    data: data
  })
}

export default workFlowTemplateManageBiz
